import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

const BASE = `${u}/note`;

export const BUILT_IN_TEMPLATES = [
  {
    id: "tpl-meeting",
    name: "Meeting Notes",
    noteType: "INFO",
    content: `<h2>Meeting Notes</h2>
<p><strong>Date:</strong> </p>
<p><strong>Attendees:</strong> </p>
<p><strong>Goal:</strong> </p>
<h3>Discussion</h3>
<ul><li></li></ul>
<h3>Action Items</h3>
<ul><li> — owner: , due: </li></ul>
<h3>Decisions Made</h3>
<ul><li></li></ul>`,
  },
  {
    id: "tpl-decision",
    name: "Decision Log",
    noteType: "INFO",
    content: `<h2>Decision Log</h2>
<p><strong>Decision:</strong> </p>
<p><strong>Date:</strong> </p>
<p><strong>Context:</strong> Why was this decision needed?</p>
<p><strong>Options considered:</strong></p>
<ul><li></li></ul>
<p><strong>Chosen option:</strong> </p>
<p><strong>Rationale:</strong> </p>
<p><strong>Risks / downsides:</strong> </p>
<p><strong>Follow-up date:</strong> </p>`,
  },
  {
    id: "tpl-standup",
    name: "Daily Standup",
    noteType: "INFO",
    content: `<h2>Daily Standup</h2>
<p><strong>Yesterday:</strong></p>
<ul><li></li></ul>
<p><strong>Today:</strong></p>
<ul><li></li></ul>
<p><strong>Blockers:</strong></p>
<ul><li>None</li></ul>`,
  },
  {
    id: "tpl-retro",
    name: "Retrospective",
    noteType: "INFO",
    content: `<h2>Retrospective</h2>
<h3>What went well?</h3>
<ul><li></li></ul>
<h3>What could be improved?</h3>
<ul><li></li></ul>
<h3>Action items for next time</h3>
<ul><li></li></ul>`,
  },
  {
    id: "tpl-goal",
    name: "Goal Plan",
    noteType: "REMINDER",
    content: `<h2>Goal Plan</h2>
<p><strong>Goal:</strong> </p>
<p><strong>Why it matters:</strong> </p>
<p><strong>Target date:</strong> </p>
<h3>Milestones</h3>
<ul><li></li></ul>
<h3>Resources needed</h3>
<ul><li></li></ul>
<h3>Progress check-ins</h3>
<ul><li></li></ul>`,
  },
];

export const getUserTemplates = async () => {
  const res = await apiFetch(`${BASE}/by-type/TEMPLATE`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

export const saveAsTemplate = async (note) => {
  const payload = {
    title: note.title + " (template)",
    content: note.content,
    noteType: "TEMPLATE",
    priority: note.priority,
  };
  const res = await apiFetch(BASE, { method: "POST", body: JSON.stringify(payload) });
  return res.json();
};
